import * as React from 'react';

import FileDwg16 from './FileDwg16';

export const fileDwg16 = () => <FileDwg16 />;

export default {
    title: 'Icon/Fill/FileDwg16',
    component: FileDwg16,
    parameters: {
        notes: "`import FileDwg16 from 'box-ui-elements/es/icon/fill/FileDwg16';`",
    },
};
